import { render, staticRenderFns } from "./StatisticalTime.vue?vue&type=template&id=6ffbfade&scoped=true"
import script from "./StatisticalTime.vue?vue&type=script&lang=js"
export * from "./StatisticalTime.vue?vue&type=script&lang=js"
import style0 from "./StatisticalTime.vue?vue&type=style&index=0&id=6ffbfade&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ffbfade",
  null
  
)

export default component.exports